function TermoEliminatoria() {
    return (
        <>
          <h3>Termos &amp; Condi&ccedil;&otilde;es</h3>
          <h4>Fase Eliminat&oacute;ria:</h4>
          <h5>1- DO CADASTRO:</h5>
          <p>O cadastro na p&aacute;gina do bol&atilde;o &eacute; gratuito.</p>
          <p>Para participar do bol&atilde;o na <b>Fase Eliminat&oacute;ria</b> ser&aacute; cobrada uma taxa, que ser&aacute; utilizada como pr&ecirc;mio para o(s) vencedor(es). Somente poder&aacute; participar quem estiver cadastrado na p&aacute;gina.</p>
          <p>Os pontos s&oacute; ser&atilde;o contabilizados ap&oacute;s a confirma&ccedil;&atilde;o do pagamento da taxa de participa&ccedil;&atilde;o.</p>
          <p>Os cancelamentos poder&atilde;o ser feitos at&eacute; 24h antes do in&iacute;cio da Fase Eliminat&oacute;ria.</p>
          <h5>2- DO PAGAMENTO:</h5>
          <p>Valor de participa&ccedil;&atilde;o: R$ 20,00</p>
          <p>O pagamento dever&aacute; ser efetuado at&eacute; o in&iacute;cio da Fase Eliminat&oacute;ria (28/06/2026).</p>
          <p>O pagamento dever&aacute; ser feito em uma das op&ccedil;&otilde;es:</p>
          <ul>
            <li>PIX: 05728397824 (Rita Elena Rosolen)</li>
            <li>Esp&eacute;cie: Juca</li>
          </ul>
          <h5>3- DO LAN&Ccedil;AMENTO DOS PALPITES:</h5>
          <p>Os palpites dever&atilde;o ser lan&ccedil;ados at&eacute; o hor&aacute;rio de in&iacute;cio do primeiro jogo de cada fase:</p>
          <ul>
            <li>16-avos de Final: 28/Jun &agrave;s 16h</li>
            <li>Oitavas de Final: 04/Jul &agrave;s 14h</li>
            <li>Quartas de Final: 09/Jul &agrave;s 17h</li>
            <li>Semifinal: 14/Jul &agrave;s 16h</li>
            <li>Terceiro Lugar e Final: 18/Jul &agrave;s 18h</li>
          </ul>
          <p>Os palpites tamb&eacute;m poder&atilde;o ser enviados por e-mail para inclus&atilde;o na p&aacute;gina, seguindo o mesmo crit&eacute;rio de prazo.</p>
          <p>Ap&oacute;s o envio, apenas os administradores poder&atilde;o alter&aacute;-los, mediante solicita&ccedil;&atilde;o por e-mail dentro do prazo.</p>
          <p>E-Mail para contato: suporte@bolaodojuca.diasferraz.com</p>
          <h5>4- DA PONTUA&Ccedil;&Atilde;O:</h5>
          <p>A pontua&ccedil;&atilde;o ser&aacute; gerada automaticamente pelo sistema web seguindo regras pr&eacute;-estabelecidas. Ser&aacute; atualizada em at&eacute; 24h ap&oacute;s as partidas.</p>
          <p>Regras de pontua&ccedil;&atilde;o:</p>
          <ul>
            <li>Acertar o placar: 10 pontos;</li>
            <li>Acertar o vencedor e o placar de um dos times: 7 pontos;</li>
            <li>Acertar somente o vencedor sem acertar o placar dos times: 5 pontos;</li>
            <li>Acertar os gols de um dos times sem acertar mais nada: 2 pontos.</li>
          </ul>
          <p>O placar para contagem no bol&atilde;o ser&aacute; o do tempo regulamentar (N&Atilde;O ser&atilde;o considerados gols na prorroga&ccedil;&atilde;o e/ou nos p&ecirc;naltis).</p>
          <h5>5- DO PR&Ecirc;MIO:</h5>
          <p>O pr&ecirc;mio ser&aacute; de 95% da soma das taxas de inscri&ccedil;&otilde;es, sendo os 5% restantes destinados &agrave; organiza&ccedil;&atilde;o e manuten&ccedil;&atilde;o do bol&atilde;o.</p>
          <h5>6- DOS VENCEDORES:</h5>
          <p>Ser&aacute; considerado vencedor(es) o(s) palpiteiro(s) que somar(em) o maior n&uacute;mero de pontos em todas as rodadas. Em caso de empate, o pr&ecirc;mio ser&aacute; dividido em partes iguais.</p>
        </>
    );
}

export default TermoEliminatoria;
